import { Fragment } from 'react';
import { Box, Stack } from '@mui/material';
import { ControlledInputs } from '@/components';

export const FormFields = () => {
  return (
    <Fragment>
      <Box display="flex" justifyContent="center">
        <Stack spacing={2} sx={{ width: 280 }}>
          <ControlledInputs.TextField
            placeholder="Enter your email address"
            ControllerProps={{
              //   control: form.control,
              name: 'email',
            }}
          />
          <ControlledInputs.PasswordField
            placeholder="Enter your password"
            ControllerProps={{
              //   control: form.control,
              name: 'password',
            }}
          />
        </Stack>
      </Box>
    </Fragment>
  );
};
